import React, { useEffect, useState } from 'react';
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { Modal, Label, TextInput, Checkbox, Button, Table, Select } from 'flowbite-react';
import { toast } from 'react-toastify'; // assuming you're using react-toastify for notifications
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Shops() {

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const [existingShops, setExistingShops] = useState([]);
    const [newShopData, setNewShopData] = useState({});
    const [shopCreateModal, setShopCreateModal] = useState(false);
    const [shopEditModal, setShopEditModal] = useState(false);
    const [existingEditShop, setExistingEditShop] = useState({});
    const [updatedShopData, setUpdatedShopData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (userDetail && userDetail.userRole !== 'Admin') {
            navigate('/buying-currency');
        }
    }, [])

    useEffect(() => {
        if (userDetail && userDetail.userRole === 'Admin' && userDetail.shopId === undefined) {
            navigate('/shopSelection');
        }
    }, [])

    const fetchShops = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + `getShops`, {
                params: {
                    userId: userDetail?._id
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const shops = response.data;
            // rates.AUD = 1;
            setExistingShops(shops);

            // console.log('shops:', existingShops)
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchShops();
    }, [])

    const createNewShop = async () => {
        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'addShop', newShopData, {
                params: {
                    userId: userDetail?._id
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 201) {
                setShopCreateModal(val => !val)
                toast.success('Shop Created Successfully.');
            }
            fetchShops();
            setIsLoading(false)

        } catch (error) {
            toast.error('Error: Shop Not Created.');
            setIsLoading(false)
        }

    }

    const handleEditShop = async (existingShop) => {
        setExistingEditShop(existingShop);
        setShopEditModal(val => !val)
    }

    const updateShop = async (id) => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + `updateShop`, {
                shopId: id,
                ...updatedShopData
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 200) {
                setShopEditModal(val => !val);
                let auth = JSON.parse(window.localStorage.getItem("auth"));
                if (auth && auth.user) {
                    auth.user.shopId = id;
                    window.localStorage.setItem("auth", JSON.stringify(auth));
                }
                toast.success('Shop Updated Successfully.');
            }
            fetchShops();
        } catch (error) {
            toast.error('Error: Shop Not Updated.');
        }
    }

    const handleDeleteShop = async (id) => {
        try {
            // Show confirmation toast with styled buttons
            const confirmDelete = await new Promise((resolve) => {
                toast(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center', // Ensure vertical centering
                        textAlign: 'center', // Center the text
                        padding: '20px', // Add some padding around the content
                    }}>
                        <FaRegTrashAlt size={30} style={{
                            marginBottom: '10px',
                            color: '#FF6347'
                        }} />
                        <span style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            marginBottom: '20px',
                            color: '#333'  // Adjust text color for better readability
                        }}>
                            Are you sure you want to delete this shop?
                        </span>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            {/* Yes Button */}
                            <button
                                onClick={() => {
                                    resolve(true);  // Resolve with true when Yes is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#05407F', // Red for Yes
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                Yes, Delete
                            </button>

                            {/* No Button */}
                            <button
                                onClick={() => {
                                    resolve(false);  // Resolve with false when No is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#ccc', // Gray for No
                                    color: 'black',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                No, Keep
                            </button>
                        </div>
                    </div>,
                    {
                        position: "top-center",
                        autoClose: false,  // Prevent auto close
                        hideProgressBar: true,  // Hide progress bar
                        closeOnClick: false,  // Prevent clicking outside to close
                        className: 'delete-toast',  // Optionally add custom class for styling
                    }
                );
            });

            if (confirmDelete) {
                // Proceed with deletion if the user confirms
                const response = await axios.post(
                    process.env.REACT_APP_API_URL + `deleteShop`,  // API URL for deletion
                    { shopId: id },  // Send shop ID in the request body
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,  // Authorization header
                        },
                    }
                );

                // Handle the response
                if (response.status === 200) {
                    toast.success('Shop Deleted Successfully.');
                    fetchShops();  // Fetch updated shop list
                }
            } else {
                toast.info('Shop deletion was canceled.');  // Inform the user if canceled
            }

        } catch (error) {
            toast.error('Error: Shop Not Deleted.');  // Show error if something goes wrong
        }
    };

    return (
        <div className="container mx-auto p-5 space-y-10 flex flex-col">
            <div className="">
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Foreign Currency Balance</h1> */}
                </div>
                <div className="flex justify-between mb-4">
                    <h1 className="text-headings text-3xl font-medium ">Shops</h1>
                    <Button className="w-52 bg-theme-secondary" onClick={() => setShopCreateModal(val => !val)}>Add Shop</Button>
                </div>
                <div className="h-[400px] overflow-x-auto bg-gray-50 dark:bg-gray-900 rounded-lg shadow-md">
                    {existingShops && existingShops.length > 0 ? (
                        <div>
                            <Table className="h-[400px]">
                                <Table.Head className="sticky top-0 z-10 bg-theme-secondary">
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Name</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Address</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Country</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Currency</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>ABN</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Phone</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Action</Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y">
                                    {existingShops && (existingShops.map((existingShop, index) => (
                                        <Table.Row key={index} className="bg-slate-200  dark:border-gray-700 dark:bg-gray-800  ">
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingShop.name}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingShop.address}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingShop.country}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingShop.currency}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingShop.abn}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingShop.phone}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;
                                                <button className={`border-0 w-7 rounded p-1 bg-#ff7675 text-green-500 hover:text-white hover:font-bold hover:bg-green-500`} onClick={() => handleEditShop(existingShop)} ><FaRegEdit className={``} /></button>
                                                <button className={`border-0 w-7 ml-1 rounded p-1 bg-#ff7675 text-red-500 hover:text-white hover:font-bold hover:bg-red-500`} onClick={() => handleDeleteShop(existingShop._id)} ><FaRegTrashAlt className={``} /></button>
                                            </Table.Cell>
                                        </Table.Row>
                                    )))}
                                </Table.Body>
                            </Table>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <h1 className='text-[2rem] text-center mt-10 text-black'>Nothing to Show</h1>
                            </div>
                        </div>
                    )}

                </div>

                {/* Flowbite Modal for Create Shop */}
                <Modal dismissible size='lg' show={shopCreateModal} onClose={() => setShopCreateModal(false)} setNewShopData={setNewShopData} createNewShop={createNewShop} >
                    <Modal.Header>Create a Shop</Modal.Header>
                    <Modal.Body>
                        <div className="flex max-w-md flex-col gap-4 mx-auto mt-5" >
                            <div className="mb-10">
                                <h2 className="text-center text-[#063A73] font-bold text-[2rem] mt-5">Shop Details</h2>
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="shopName" value="Shop Name" />
                                </div>
                                <TextInput
                                    name="shopName"
                                    type="text"
                                    placeholder="Enter Your Shop Name"
                                    // value={name}
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="address" value="Address" />
                                </div>
                                <TextInput
                                    name="shopAddress"
                                    type="text"
                                    placeholder="Enter Shop Address"
                                    // value={email}
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="shopCountry" value="Country" />
                                </div>
                                <TextInput
                                    name="shopCountry"
                                    type="text"
                                    placeholder="Enter Shop's Country"
                                    // value={email}
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="shopCurrency" value="Currency" />
                                </div>
                                <TextInput
                                    name="shopCurrency"
                                    type="text"
                                    placeholder="Enter Shop's Currency"
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="abn" value="ABN" />
                                </div>
                                <TextInput
                                    name="abn"
                                    type="text"
                                    placeholder="Enter Shop's ABN"
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="phone" value="Phone Number" />
                                </div>
                                <TextInput
                                    name="phone"
                                    type="tel"
                                    placeholder="Enter Shop's Phone Number"
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            {/* <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="password" value="Password" />
                                </div>
                                <TextInput
                                    name="password"
                                    type="password"
                                    placeholder="Enter Shop's Password"
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div> */}
                            {/* <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="confirmPassword" value="Confirm Password" />
                                </div>
                                <TextInput
                                    name="confirmPassword"
                                    type="password"
                                    placeholder="Confirm Password"
                                    onChange={(e) => setNewShopData({
                                        ...newShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div> */}

                            <button
                                onClick={createNewShop}
                                disabled={!newShopData.shopName || !newShopData.shopAddress || !newShopData.shopCurrency || !newShopData.shopCountry || !newShopData.abn || !newShopData.phone}
                                // disabled={!newShopData.shopName || !newShopData.shopAddress || !newShopData.shopCurrency || !newShopData.shopCountry || !newShopData.password || !newShopData.confirmPassword || newShopData.password !== newShopData.confirmPassword}
                                className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg"
                            >
                                Create
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Flowbite Modal for Edit Shop */}
                <Modal dismissible size='lg' show={shopEditModal} onClose={() => setShopEditModal(false)} existingEditShop={existingEditShop} setUpdatedShopData={setUpdatedShopData} updateShop={updateShop} >
                    <Modal.Header>Edit Shop</Modal.Header>
                    <Modal.Body>
                        <div className="flex max-w-md flex-col gap-4 mx-auto mt-5" >
                            <div className="mb-10">
                                <h2 className="text-center text-[#063A73] font-bold text-[2rem] mt-5">Shop Details</h2>
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="shopName" value="Shop Name" />
                                </div>
                                <TextInput
                                    name="shopName"
                                    type="text"
                                    placeholder="Enter Your Shop Name"
                                    defaultValue={existingEditShop.name}
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="address" value="Address" />
                                </div>
                                <TextInput
                                    name="shopAddress"
                                    type="text"
                                    placeholder="Enter Shop Address"
                                    defaultValue={existingEditShop.address}
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="shopCountry" value="Country" />
                                </div>
                                <TextInput
                                    name="shopCountry"
                                    type="text"
                                    placeholder="Enter Shop's Country"
                                    defaultValue={existingEditShop.country}
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="shopCurrency" value="Currency" />
                                </div>
                                <TextInput
                                    name="shopCurrency"
                                    type="text"
                                    placeholder="Enter Shop's Currency"
                                    defaultValue={existingEditShop.currency}
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="abn" value="ABN" />
                                </div>
                                <TextInput
                                    name="abn"
                                    type="text"
                                    placeholder="Enter Shop's ABN"
                                    defaultValue={existingEditShop.abn}
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="phone" value="Phone Number" />
                                </div>
                                <TextInput
                                    name="phone"
                                    type="tel"
                                    placeholder="Enter Shop's Phone Number"
                                    defaultValue={existingEditShop.phone}
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            {/* <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="password" value="Change Password" />
                                </div>
                                <TextInput
                                    name="password"
                                    type="password"
                                    placeholder="Enter Shop's New Password"
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div> */}
                            {/* <div className={`${updatedShopData && updatedShopData.password ? '': 'hidden'}`}>
                                <div className="mb-2 block">
                                    <Label htmlFor="confirmPassword" value="Confirm Password" />
                                </div>
                                <TextInput
                                    name="confirmPassword"
                                    type="password"
                                    placeholder="Confirm New Password"
                                    onChange={(e) => setUpdatedShopData({
                                        ...updatedShopData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div> */}

                            <button
                                onClick={() => updateShop(existingEditShop._id)}
                                // disabled={updatedShopData.password && updatedShopData.password !== updatedShopData.confirmPassword}
                                className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg"
                            >
                                Update
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        </div>
    );
}

export default Shops;

